export default __webpack_public_path__ + "static/media/Specifikace služby připojení k internetu.d904b4d8.pdf";